import React, { useEffect, useState } from 'react';
import { useTitle } from '../../Hooks';
import { Link, useParams } from 'react-router-dom';
import { Payout as P, UserPayment } from '../../Classes';
import { Header, Table, Button } from 'react-frontier';
import { addCommas, bindClick } from '@tempu/components/Util';
import { Modal, PayoutModal } from '../../components';
import moment from 'moment';
import classNames from 'classnames';
import API from '../../API';

var Payout = () =>{
	var params = useParams<{ payout_id: string }>();
	var payout_id = parseInt(params?.payout_id);
	var { setTitle } = useTitle(); 
	var [loadError, setLoadError] = useState<string>(null);
	var [payout, setPayout] = useState<P>(null);
	var [completeModal, setCompleteModal] = useState<boolean>(false);
	var [userPaymentModal, setUserPaymentModal] = useState<boolean>(false);
	var [userPayment, setUserPayment] = useState<UserPayment>(null);

	useEffect(()=>{
		setTitle('Liquidaciones')
		API.getAdminPayout(payout_id).then(res=>{
			if(res.error) return setLoadError(res.message);
			setPayout(res.data);
		}).catch(e=>{
			return setLoadError('Hubo un error inesperado cargando la liquidacion. (LCL-1)');
		});
		
	}, []);

	if(loadError){
		return <Header text='Error' subtext={loadError} />
	}

	if(!payout){
		return <Header loading text='Cargando datos' />;
	}

	var viewUserPayment = (payment: UserPayment)=>{
		setUserPayment(payment);
		setUserPaymentModal(true);
	}

	var completePayout = ()=>{
		setPayout((pp) => ({
			...pp,
			paid: true,
			date_paid: moment().unix(),
			users: pp.users.map((user) => ({
				...user,
				paid: true,
				date_paid: moment().unix(),
			})),
		}));
	}

	var paid = payout.users.reduce((total, user) => {return user.paid ? total + user.amount : total}, 0);
	var total = payout.users.reduce((total, user) => {return total + user.amount}, 0);

	return <div className='tp payout-screen'>
		<Table
			title={'Liquidación ' + payout.payout_id}
			details
			striped
			actions={!payout.paid && !payout.cancelled &&
				<>
					<Button text='Cancelar' basic color='red'/>
					<Button style={{ marginLeft: 10 }} text='Completar' color='green' onClick={bindClick(setCompleteModal, true)}/>
				</>
			}
			data={[
				['ID', payout.payout_id],
				['Negocio', <Link to={`/business/${payout.business_id}`}>{payout.business_name}</Link>],
				['Empleo', <Link to={`/business/${payout.business_id}/posting/${payout.posting_id}`}>{payout.posting_name}</Link>],
				['Estatus', <div className={classNames("fr label", {
					green: payout.paid && !payout.cancelled,
					yellow: !payout.paid && !payout.cancelled,
					red: payout.cancelled
				})}>
					{payout.cancelled ? 'Cancelada' : payout.paid ? 'Pagada' : 'Pendiente'}
				</div>],
				['Pagos', payout.users.length],
				payout.paid ? ['Deposito', moment.unix(payout.date_paid).format('DD/MMM/YY HH:mm')] : null,
				['Pagado', '$' + addCommas(paid)],	
				['Liquidación', '$' + addCommas(total)],
			].filter(row => row !== null)}
		/>
		<Table
			title='Pagos'
			selectable
			headers={['ID', 'Usuario', 'Fecha', 'Estatus', 'Monto']}
			collapsingIndexes={[0, 4]}
		>
			{payout.users.map(u=>(
			<Table.Row onClick={() => viewUserPayment(u)}>
				<Table.Cell>{u.payment_id}</Table.Cell>
				<Table.Cell>{u.user_name}</Table.Cell>
				<Table.Cell>{moment.unix(!u.paid ? u.date_created : u.date_paid).format('DD/MMM/YY HH:mm')}</Table.Cell>
				<Table.Cell> 
					<div className={classNames("fr label", {
						green: u.paid && !u.cancelled,
						yellow: !u.paid && !u.cancelled,
						red: u.cancelled
					})}>
						{u.cancelled ? 'Cancelada' : u.paid ? 'Pagado' : 'Pendiente'}
					</div>
				</Table.Cell>
				<Table.Cell>{'$' + addCommas(u.amount)}</Table.Cell>
			</Table.Row>
			))}
		</Table>
		<Table
			details
			striped
			title='usuarios'
			data={[
				['Creador', <div className='users'>
					<Link to={''}>{payout.user_creator_name.toUpperCase()}</Link>
					<div className='id'>ID: {payout.user_creator}</div>
				</div>],
				['Fecha creación', moment.unix(payout.date_created).format('DD/MMM/YY HH:mm')],
				payout.paid ? [] : null,
				payout.paid ? ['Deposito', <div className='users'>
					<Link to={''}>{payout.user_payer_name?.toUpperCase()}</Link>
					<div className='id'>ID: {payout.user_paid || null}</div>
				</div>] : null,
				payout.paid ? ['Fecha deposito', moment.unix(payout.date_paid).format('DD/MMM/YY HH:mm')] : null,
			].filter(row => row !== null)}
		/>
		<Modal open={userPaymentModal} onClose={bindClick(setUserPaymentModal)} size='tiny'>
			<Modal.Header>Información de pago</Modal.Header>
			{userPayment && <Modal.Content>
				<Table
					details
					title='Información'
					data={[
						['ID', userPayment.payment_id],
						['Puesto', userPayment.job_name],
						['Usuario', userPayment.user_name],
						['Fecha creación', moment.unix(payout.date_created).format('DD/MMM/YY HH:mm')],
						['Estatus', <div className={classNames("fr label", {
							green: userPayment.paid && !userPayment.cancelled,
							yellow: !userPayment.paid && !userPayment.cancelled,
							red: userPayment.cancelled
						})}>
							{userPayment.cancelled ? 'Cancelada' : userPayment.paid ? 'Pagado' : 'Pendiente'}
						</div>],
						userPayment.payer_name ? ['Pago', userPayment.payer_name] : null,
						userPayment.paid ? ['Fecha de pago', moment.unix(userPayment.date_paid).format('DD/MMM/YY HH:mm')] : null,
						['Referencia', userPayment.message || 'Sin Referencia']
					].filter(row => row !== null)}
				/>
			</Modal.Content>}
			<Modal.Actions>
				<Button text='Cerrar' basic onClick={bindClick(setUserPaymentModal)} />
			</Modal.Actions>
		</Modal>
		<PayoutModal
			open={completeModal}
			payouts={[payout]}
			onComplete={completePayout}
			onClose={() => setCompleteModal(false)}
		/>
	</div>
}

export default Payout;